<template>
  <div class="watermark-overlay" aria-hidden="true">
    <span
      v-for="item in items"
      :key="item.key"
      class="watermark-item"
      :style="item.style"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'WatermarkOverlay',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  computed: {
    items() {
      const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
      const rows = isMobile ? 5 : 8;
      const cols = isMobile ? 3 : 6;
      const result = [];
      for (let row = 0; row < rows; row += 1) {
        for (let col = 0; col < cols; col += 1) {
          result.push({
            key: `${row}-${col}`,
            style: {
              left: `${(col + 0.5) * (100 / cols)}%`,
              top: `${(row + 0.5) * (100 / rows)}%`,
              transform: `translate(-50%, -50%) rotate(${row % 2 === 0 ? -18 : -12}deg)`,
            },
          });
        }
      }
      return result;
    },
  },
};
</script>

<style scoped>
.watermark-overlay {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 15;
  overflow: hidden;
}

.watermark-item {
  position: absolute;
  font-size: 13px;
  font-weight: 700;
  color: rgba(100, 116, 139, 0.16);
  white-space: nowrap;
  user-select: none;
  letter-spacing: 1px;
}

@media (max-width: 768px) {
  .watermark-item {
    font-size: 11px;
    color: rgba(100, 116, 139, 0.08);
    letter-spacing: 0.5px;
  }
}
</style>
